import { Flex, Space, Tag, theme, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { Text, Paragraph } = Typography;

export const InfoItem = ({ icon, iconColor, label, children }) => {
  const { token: themeToken } = theme.useToken();
  const finalIconColor = iconColor ?? themeToken.colorPrimary;

  return (
    <Space size='middle' align='center'>
      <Tag
        style={{
          fontSize: '1em',
          margin: 0,
          padding: 8,
          borderRadius: 8,
          lineHeight: 0,
        }}
        color={`${finalIconColor}0d`} // 5% de opacidad
      >
        <FontAwesomeIcon icon={icon} color={finalIconColor} />
      </Tag>
      <Flex vertical align='start'>
        <Text type='secondary' style={{ whiteSpace: 'nowrap', fontSize: '0.9em' }}>
          {label}
        </Text>
        <Paragraph strong ellipsis={{ rows: 2 }} style={{ marginBottom: 0 }}>
          {children}
        </Paragraph>
      </Flex>
    </Space>
  );
};